import React from "react";
import AppShell from "../components/AppShell";
import PageHero from "../components/PageHero";
import AssistantChat from "../components/AssistantChat";
import VoiceMode from "../components/VoiceMode";
import UsageMeter from "../components/UsageMeter";
import { Sparkles } from "lucide-react";

export default function Assistant() {
  return (
    <AppShell title="AI Assistant">
      <div className="w-full">
        <PageHero
          eyebrow="CPG Institute Assistant"
          icon={Sparkles}
          title={<>Ask <span className="text-grad">Morgan</span></>}
          subtitle="Course-aware for the 16 modules, and connected to Claude & ChatGPT for open CPG questions. Tap the speaker on any answer to hear it in Morgan's voice, or start a live conversation."
        />

        <div className="mt-8">
          <VoiceMode />
        </div>

        <div className="mt-6">
          <AssistantChat variant="page" />
        </div>

        <div className="mt-6">
          <UsageMeter />
        </div>
      </div>
    </AppShell>
  );
}
